import { render, staticRenderFns } from "./editSEOPage.vue?vue&type=template&id=48740926&lang=pug"
import script from "./editSEOPage.vue?vue&type=script&lang=js"
export * from "./editSEOPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports